import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { AlertTriangle, X } from "react-feather";
import { all_routes } from "../../../Router/all_routes";

const DISMISS_KEY = "profileBannerDismissed";

const ProfileBanner = () => {
  const routes = all_routes;
  const { userData } = useSelector((state) => ({ userData: state.user_detail }));
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!userData?.id) return;
    const isComplete = userData?.ntn_cnic && userData?.strn;
    const dismissed = localStorage.getItem(`${DISMISS_KEY}_${userData.id}`);
    const shouldShow = !isComplete && !dismissed;
    setVisible(shouldShow);

    if (shouldShow) {
      document.body.classList.add("has-profile-banner");
    } else {
      document.body.classList.remove("has-profile-banner");
    }

    return () => {
      document.body.classList.remove("has-profile-banner");
    };
  }, [userData]);

  const dismiss = () => {
    localStorage.setItem(`${DISMISS_KEY}_${userData.id}`, "true");
    setVisible(false);
    document.body.classList.remove("has-profile-banner");
  };

  if (!visible) return null;

  const missing = [];
  if (!userData?.ntn_cnic) missing.push("NTN/CNIC");
  if (!userData?.strn) missing.push("STRN");

  return (
    <div className="profile-banner-fixed">
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <AlertTriangle size={18} color="#F59E0B" style={{ flexShrink: 0 }} />
        <span style={{ fontSize: 13, color: "#92400E" }}>
          <strong>Profile incomplete:</strong> Your {missing.join(" and ")}{" "}
          {missing.length > 1 ? "are" : "is"} missing. These fields pre-fill automatically on every invoice.{" "}
          <Link to={routes.profile} style={{ color: "#D97706", fontWeight: 600, textDecoration: "underline" }}>
            Complete your profile →
          </Link>
        </span>
      </div>
      <button
        onClick={dismiss}
        style={{ background: "none", border: "none", cursor: "pointer", padding: 2, flexShrink: 0 }}
        title="Dismiss"
      >
        <X size={16} color="#92400E" />
      </button>
    </div>
  );
};

export default ProfileBanner;
